export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const RESET_CATEGORY = 'RESET_CATEGORY';